import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsGL: CultureInfo = {
  name: 'es-GL',
  displayName: 'español (Groenlandia)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-GL',
  parent: CultureInfoEs
};
